<template>
  <div class="sk" :class="isLandscape ? 'land' : 'port'" dir="rtl" v-if="form">
    <!-- شريط الأدوات (لا يُطبع) -->
    <div class="sk-toolbar">
      <button class="btn btn-success" @click="print()">
        <span>🖨️ طباعة الآن</span>
      </button>
      <button class="btn btn-outline-danger" @click="resetForm()">
        <span>🗑️ تفريغ الحقول</span>
      </button>
      <span class="sk-hint">
        ✓ يُحفظ تلقائياً في هذا المتصفح — عند عودتك تجد آخر ما كتبته. املأ الحقول واختر
        المعلم/الطالب من القائمة أو اكتب يدوياً.
      </span>
    </div>

    <!-- مصادر الاختيار السريع (معلمون/طلاب) -->
    <datalist id="dl-teachers">
      <option v-for="(t, i) in teacherNames" :key="'t' + i" :value="t" />
    </datalist>
    <datalist id="dl-students">
      <option v-for="(s, i) in studentNames" :key="'s' + i" :value="s" />
    </datalist>

    <div class="sk-page">
      <!-- ===== الترويسة المشتركة ===== -->
      <table class="sk-head">
        <tr>
          <td class="r">
            <div class="bold">المملكة العربية السعودية</div>
            <div class="bold">وزارة التعليم</div>
            <div class="bold">{{ info.edara || "الإدارة العامة للتعليم" }}</div>
            <div class="bold">مدرسة {{ info.school }}</div>
          </td>
          <td class="c">
            <img :src="require('@/assets/images/banner.webp')" class="logo" />
          </td>
          <td class="l">
            <div class="box">
              <div>العام الدراسي&nbsp;&nbsp;{{ hyear }}</div>
              <div>الفصل الدراسي&nbsp;&nbsp;{{ semster }}</div>
              <div>الدور&nbsp;&nbsp;الأول</div>
            </div>
          </td>
        </tr>
      </table>

      <!-- شريط اسم النموذج ورقمه -->
      <table class="sk-title">
        <tr>
          <td class="lbl">اسم النموذج</td>
          <td class="val">{{ form.name }}</td>
          <td class="lbl">رقم النموذج</td>
          <td class="num">{{ form.num }}</td>
        </tr>
      </table>

      <!-- ============================ قرار تشكيل لجنة ============================ -->
      <div v-if="form.type === 'committee'">
        <p class="intro">
          إن مدير المدرسة، وبناءً على الصلاحيات الممنوحة له، وبناءً على ما تقتضيه
          المصلحة العامة، يقرر تشكيل {{ form.decision }}
          <template v-if="form.subjectLine">
            مادة: <input class="inline" v-model="subjectName" placeholder="........" />
            ومقرها: <input class="inline" v-model="subjectPlace" placeholder="........" />
          </template>
          على النحو التالي:
        </p>

        <table class="sk-grid" style="table-layout: fixed; width: 100%">
          <thead>
            <tr>
              <th style="width: 5%">م</th>
              <th>{{ form.membersHeader || "الاسم" }}</th>
              <th v-if="form.membersCol !== 'none'" style="width: 22%">العمل</th>
              <th style="width: 14%">الصفة</th>
              <th v-if="form.membersCol === 'task'" style="width: 16%">المهمة</th>
              <th style="width: 18%">التوقيع</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(m, i) in members" :key="i">
              <td class="center">
                {{ i + 1 }}
                <button class="row-del" @click="members.splice(i, 1)" title="حذف">×</button>
              </td>
              <td>
                <input
                  class="cell"
                  list="dl-teachers"
                  v-model="m.name"
                  placeholder="اكتب الاسم أو اختر معلماً"
                />
              </td>
              <td v-if="form.membersCol !== 'none'">
                <input class="cell" v-model="m.work" />
              </td>
              <td><input class="cell" v-model="m.role" /></td>
              <td v-if="form.membersCol === 'task'">
                <input class="cell" v-model="m.task" />
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <button class="add-row" @click="members.push({ name: '', work: '', role: 'عضواً', task: '' })">
          + إضافة عضو
        </button>

        <div class="tasks-title">{{ form.tasksTitle || "مهام اللجنة:" }}</div>
        <ol class="tasks">
          <li v-for="(t, i) in form.tasks" :key="i">{{ t }}</li>
        </ol>

        <div class="sign-row">
          <div>مدير المدرسة: {{ info.boss || info.admin }}</div>
          <div>التوقيع: ............................</div>
        </div>
        <div class="note">• يحفظ بملف أعمال الاختبارات.</div>
      </div>

      <!-- ============================ تكليف معلم (7) ============================ -->
      <div v-else-if="form.type === 'assignment'">
        <p class="intro">
          المكرم الأستاذ /
          <input class="inline w-50" list="dl-teachers" v-model="assignTeacher" placeholder="اسم المعلم" />
          &nbsp;&nbsp;وفقه الله
        </p>
        <p class="intro">
          السلام عليكم ورحمة الله وبركاته ... وبعد: نظراً لقرب اختبارات الفصل
          الدراسي ({{ semster }}) لعام ({{ hyear }}) فقد تقرر تكليفكم بوضع الأسئلة
          ونماذج الإجابة وفق الآتي:
        </p>

        <table class="sk-grid" style="table-layout: fixed; width: 100%">
          <thead>
            <tr>
              <th style="width: 6%">م</th>
              <th>المادة</th>
              <th style="width: 22%">الصف / المستوى</th>
              <th style="width: 22%">المسار</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(s, i) in subjects" :key="i">
              <td class="center">
                {{ i + 1 }}
                <button class="row-del" @click="subjects.splice(i, 1)">×</button>
              </td>
              <td><input class="cell" v-model="s.subject" /></td>
              <td><input class="cell" v-model="s.grade" /></td>
              <td><input class="cell" v-model="s.track" /></td>
            </tr>
          </tbody>
        </table>
        <button class="add-row" @click="subjects.push({ subject: '', grade: '', track: '' })">
          + إضافة مادة
        </button>

        <div class="tasks-title">معايير وشروط إعداد الأسئلة:</div>
        <ol class="tasks">
          <li v-for="(t, i) in form.tasks" :key="i">{{ t }}</li>
        </ol>

        <div class="sign-row">
          <div>مدير المدرسة: {{ info.boss || info.admin }}</div>
          <div>التوقيع: ............................</div>
        </div>
        <div class="note">• يحفظ صورة بملف أعمال الاختبارات.</div>
      </div>

      <!-- ============================ جدول متابعة (8) ============================ -->
      <div v-else-if="form.type === 'tracking'">
        <table class="sk-grid tracking" style="table-layout: fixed; width: 100%">
          <thead>
            <tr>
              <th style="width: 4%">م</th>
              <th v-for="(c, i) in form.columns" :key="i">{{ c }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, ri) in trackRows" :key="ri">
              <td class="center">{{ ri + 1 }}</td>
              <td v-for="(c, ci) in form.columns" :key="ci">
                <input class="cell" :list="listFor(ci)" v-model="row[ci]" />
              </td>
            </tr>
          </tbody>
        </table>
        <button class="add-row" @click="addTrackRow()">+ إضافة صف</button>
        <div class="note">• يحفظ بملف أعمال الاختبارات.</div>
      </div>

      <!-- ============================ ظرف (19/20/21/40) ============================ -->
      <div v-else-if="form.type === 'envelope'">
        <table class="sk-env">
          <tr v-for="(f, i) in form.fields" :key="i">
            <td class="k">{{ f.label }}</td>
            <td class="v">
              <template v-if="f.options">
                <label v-for="op in f.options" :key="op" class="opt">
                  <input type="checkbox" :value="op" v-model="envOpts[f.label]" />
                  {{ op }}
                </label>
              </template>
              <input
                v-else
                class="cell"
                :list="f.src === 'teacher' ? 'dl-teachers' : f.src === 'student' ? 'dl-students' : null"
                v-model="env[f.label]"
              />
            </td>
          </tr>
        </table>
        <div class="note">• يحفظ بملف أعمال الاختبارات.</div>
      </div>

      <!-- ============================ بطاقة متابعة (13/14/15/16) ============================ -->
      <div v-else-if="form.type === 'card'">
        <table class="sk-grid sk-card" style="table-layout: fixed; width: 100%" v-if="form.variant === 'checklist'">
          <colgroup>
            <col style="width: 5%" />
            <col style="width: 55%" />
            <col style="width: 8%" />
            <col style="width: 8%" />
            <col style="width: 24%" />
          </colgroup>
          <thead>
            <tr>
              <th>م</th>
              <th>العمل المطلوب</th>
              <th>تم</th>
              <th>لا</th>
              <th>ملاحظات على التنفيذ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(it, i) in form.items" :key="i">
              <td class="center">{{ i + 1 }}</td>
              <td class="rightcell">{{ it }}</td>
              <td><input type="checkbox" v-model="cardRows[i].done" /></td>
              <td><input type="checkbox" v-model="cardRows[i].no" /></td>
              <td><input class="cell" v-model="cardRows[i].notes" /></td>
            </tr>
          </tbody>
        </table>
        <table class="sk-grid sk-card days" style="table-layout: fixed; width: 100%" v-else>
          <colgroup>
            <col style="width: 4%" />
            <col style="width: 38%" />
            <col v-for="d in form.days" :key="'col-' + d" style="width: 11.6%" />
          </colgroup>
          <thead>
            <tr>
              <th>م</th>
              <th>العمل المطلوب</th>
              <th class="dcol" v-for="d in form.days" :key="d">{{ d }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(it, i) in form.items" :key="i">
              <td class="center">{{ i + 1 }}</td>
              <td class="rightcell">{{ it }}</td>
              <td v-for="d in form.days" :key="d">
                <input type="checkbox" v-model="cardRows[i].days[d]" />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="note">• يحفظ بملف أعمال الاختبارات.</div>
      </div>

      <!-- ============================ محضر (26-35، 46، 49) ============================ -->
      <div v-else-if="form.type === 'minutes'">
        <template v-for="(blk, bi) in form.blocks">
          <p v-if="blk.b === 'para'" :key="bi" class="intro">{{ blk.text }}</p>

          <table v-else-if="blk.b === 'info'" :key="bi" class="sk-env">
            <tr v-for="(f, fi) in blk.fields" :key="fi">
              <td class="k">{{ f.label }}</td>
              <td class="v">
                <input class="cell" :list="srcList(f.src)" v-model="mstate['i' + bi][f.label]" />
              </td>
            </tr>
          </table>

          <div v-else-if="blk.b === 'checks'" :key="bi" class="checks">
            <span class="checks-lbl">{{ blk.label }}</span>
            <label v-for="op in blk.options" :key="op" class="opt">
              <input type="checkbox" :value="op" v-model="mstate['c' + bi]" /> {{ op }}
            </label>
          </div>

          <div v-else-if="blk.b === 'lines'" :key="bi" class="lines">
            <div class="lines-lbl">{{ blk.label }}</div>
            <textarea class="lines-area" :rows="blk.n || 2" v-model="mstate['l' + bi]"></textarea>
          </div>

          <div v-else-if="blk.b === 'signs'" :key="bi" class="signs">
            <div v-if="blk.label" class="signs-lbl">{{ blk.label }}</div>
            <div v-for="(it, ii) in blk.items" :key="ii" class="sign-line">
              <span>الاسم: <span class="dots"></span></span>
              <span v-if="it.role">الصفة: {{ it.role }}</span>
              <span>التوقيع: <span class="dots"></span></span>
            </div>
          </div>

          <div v-else-if="blk.b === 'members'" :key="bi">
            <div v-if="blk.header" class="tasks-title">{{ blk.header }}</div>
            <table class="sk-grid" style="table-layout: fixed; width: 100%">
              <thead>
                <tr v-if="blk.mode === 'student'">
                  <th style="width: 5%">م</th>
                  <th>اسم الطالب</th>
                  <th style="width: 18%">رقم الجلوس</th>
                  <th style="width: 22%">الصف / المستوى</th>
                  <th style="width: 16%">التوقيع</th>
                </tr>
                <tr v-else-if="blk.mode === 'subjects'">
                  <th style="width: 5%">م</th>
                  <th>المادة</th>
                  <th style="width: 30%">النتيجة</th>
                  <th style="width: 22%">توقيع المعلم</th>
                </tr>
                <tr v-else-if="blk.mode === 'grades'">
                  <th style="width: 5%">م</th>
                  <th>اسم الطالب رباعياً</th>
                  <th style="width: 18%">رقم الهوية</th>
                  <th style="width: 12%">الصف</th>
                  <th>المواد</th>
                  <th style="width: 16%">الدرجة المستحقة</th>
                </tr>
                <tr v-else>
                  <th style="width: 5%">م</th>
                  <th>الاسم</th>
                  <th style="width: 24%">العمل</th>
                  <th style="width: 14%">الصفة</th>
                  <th style="width: 18%">التوقيع</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r, ri) in mstate['m' + bi]" :key="ri">
                  <td class="center">
                    {{ ri + 1 }}
                    <button class="row-del" @click="mstate['m' + bi].splice(ri, 1)">×</button>
                  </td>
                  <template v-if="blk.mode === 'student'">
                    <td><input class="cell" list="dl-students" v-model="r.name" /></td>
                    <td><input class="cell" v-model="r.seat" /></td>
                    <td><input class="cell" v-model="r.class" /></td>
                    <td></td>
                  </template>
                  <template v-else-if="blk.mode === 'subjects'">
                    <td><input class="cell" v-model="r.subject" /></td>
                    <td></td>
                    <td></td>
                  </template>
                  <template v-else-if="blk.mode === 'grades'">
                    <td><input class="cell" list="dl-students" v-model="r.name" /></td>
                    <td><input class="cell" v-model="r.id" /></td>
                    <td><input class="cell" v-model="r.class" /></td>
                    <td><input class="cell" v-model="r.subjects" /></td>
                    <td></td>
                  </template>
                  <template v-else>
                    <td><input class="cell" list="dl-teachers" v-model="r.name" /></td>
                    <td><input class="cell" v-model="r.work" /></td>
                    <td><input class="cell" v-model="r.role" /></td>
                    <td></td>
                  </template>
                </tr>
              </tbody>
            </table>
            <button class="add-row" @click="addMemberRow(bi, blk.mode)">+ إضافة صف</button>
          </div>

          <div v-else-if="blk.b === 'boss'" :key="bi" class="sign-row">
            <div>مدير المدرسة: {{ info.boss || info.admin }}</div>
            <div>التوقيع: ............................</div>
          </div>

          <div v-else-if="blk.b === 'note'" :key="bi" class="note">• {{ blk.text }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getForm } from "./school-kushof-data";

var user = JSON.parse(localStorage.getItem("user"));

// صف عضو/طالب كامل الحقول حسب النمط (لضمان تفاعلية Vue 2)
function makeMemberRow(mode, r) {
  r = r || {};
  if (mode === "student") return { name: r.name || "", seat: r.seat || "", class: r.class || "" };
  if (mode === "subjects") return { subject: r.subject || "" };
  if (mode === "grades")
    return { name: r.name || "", id: r.id || "", class: r.class || "", subjects: r.subjects || "" };
  return { name: r.name || "", work: r.work || "", role: r.role || "عضواً" };
}

export default {
  data() {
    var id = window.location.pathname.split("school-kushof/")[1];
    var form = getForm(id);
    var hy = typeof hyear !== "undefined" ? hyear : localStorage.getItem("hyear");
    // تعبئة قيم نموذج "الظرف" الأولية (مع ربط العام الدراسي تلقائياً)
    var env = {};
    var envOpts = {};
    if (form && form.fields) {
      form.fields.forEach(function (f) {
        env[f.label] = f.bind === "hyear" ? hy || "" : "";
        if (f.options) envOpts[f.label] = [];
      });
    }
    // حالة نموذج "المحضر" (مبني على كتل) — نهيّئ حقلاً لكل كتلة
    var mstate = {};
    if (form && form.blocks) {
      form.blocks.forEach(function (blk, i) {
        if (blk.b === "info") {
          var o = {};
          blk.fields.forEach(function (f) {
            o[f.label] = f.bind === "hyear" ? hy || "" : "";
          });
          mstate["i" + i] = o;
        } else if (blk.b === "checks") {
          mstate["c" + i] = [];
        } else if (blk.b === "lines") {
          mstate["l" + i] = "";
        } else if (blk.b === "members") {
          mstate["m" + i] = (blk.rows || []).map(function (r) {
            return makeMemberRow(blk.mode, r);
          });
        }
      });
    }
    // حالة نموذج "البطاقة" (قائمة تحقق) — صف لكل بند
    var cardRows = [];
    if (form && form.items) {
      cardRows = form.items.map(function () {
        var days = {};
        if (form.days) form.days.forEach(function (d) { days[d] = false; });
        return { done: false, no: false, notes: "", days: days };
      });
    }
    return {
      id,
      form,
      info: localStorage.getItem("info")
        ? JSON.parse(localStorage.getItem("info"))
        : { edara: "", school: "", admin: "", boss: "", maktab: "" },
      hyear: hy,
      semster: typeof semster !== "undefined" ? semster : localStorage.getItem("semster"),
      teachers: [],
      students: [],
      // حالة قابلة للتعبئة لكل نموذج
      members: form && form.members ? JSON.parse(JSON.stringify(form.members)) : [],
      subjects: [{ subject: "", grade: "", track: "" }],
      trackRows: [],
      env: env,
      envOpts: envOpts,
      mstate: mstate,
      cardRows: cardRows,
      subjectName: "",
      subjectPlace: "",
      assignTeacher: "",
    };
  },
  computed: {
    // مفتاح حفظ بيانات هذا النموذج في المتصفح (خاص بكل نموذج)
    storageKey() {
      return "school-kushof:" + this.id;
    },
    isLandscape() {
      // الجداول العريضة جداً (متابعة المعلمين/الطلاب) تُطبع أفقياً. البقية عمودية.
      return this.form && this.form.type === "tracking";
    },
    teacherNames() {
      return this.teachers.map((t) => t.name).filter(Boolean);
    },
    studentNames() {
      return this.students.map((s) => s.name).filter(Boolean);
    },
  },
  created() {
    var g = this;
    if (!this.form) return;
    // تجهيز صفوف نموذج المتابعة
    if (this.form.type === "tracking") {
      for (var i = 0; i < (this.form.rows || 10); i++) {
        this.trackRows.push(this.form.columns.map(() => ""));
      }
    }
    // استعادة آخر ما كتبه المستخدم في هذا النموذج (إن وُجد)
    this.loadState();
    // الحفظ التلقائي: أي تعديل على أي حقل يُحفظ في المتصفح (مع تأخير بسيط)
    this.$watch(
      function () {
        return JSON.stringify(this.collect());
      },
      function (val) {
        var g = this;
        clearTimeout(g._saveTimer);
        g._saveTimer = setTimeout(function () {
          try {
            localStorage.setItem(g.storageKey, val);
          } catch (e) {}
        }, 250);
      }
    );
    // تحميل المعلمين
    $.post(api + "/user/teachers/list", { jwt: user.jwt })
      .then(function (r) {
        if (r.status == 100 || r.response) g.teachers = r.response || [];
      })
      .catch(function () {});
    // تحميل الطلاب
    $.post(api + "/user/students/list", { jwt: user.jwt, page: 1, perpage: 10000 })
      .then(function (r) {
        if (r.status == 100) g.students = r.response || [];
      })
      .catch(function () {});
  },
  mounted() {
    // اتجاه طباعة هذا النموذج. مهم: نحذف أي قاعدة @page سابقة (من نموذج فُتح قبله عبر الـ SPA)
    // وإلا يتراكم اتجاه قديم (مثلاً أفقي) فيُخطّط كروم الصفحة بعرض خاطئ ويقصّها.
    var prev = document.getElementById("sk-page-orientation");
    if (prev) prev.parentNode.removeChild(prev);
    var style = document.createElement("style");
    style.id = "sk-page-orientation";
    style.innerHTML =
      "@page { size: A4 " + (this.isLandscape ? "landscape" : "portrait") + "; margin: 8mm; }";
    document.head.appendChild(style);
    document.documentElement.setAttribute("dir", "rtl");
    // عند الطباعة ننقل الكشف إلى body مباشرةً (يتجاوز حاويات القالب في كروم وسفاري)
    this._onBeforePrint = this.relocateForPrint;
    this._onAfterPrint = this.restoreAfterPrint;
    window.addEventListener("beforeprint", this._onBeforePrint);
    window.addEventListener("afterprint", this._onAfterPrint);
  },
  beforeDestroy() {
    window.removeEventListener("beforeprint", this._onBeforePrint);
    window.removeEventListener("afterprint", this._onAfterPrint);
    this.restoreAfterPrint();
    var s = document.getElementById("sk-page-orientation");
    if (s) s.parentNode.removeChild(s);
  },
  methods: {
    // تجميع كل الحالة القابلة للتعبئة في كائن واحد (للحفظ)
    collect() {
      return {
        members: this.members,
        subjects: this.subjects,
        trackRows: this.trackRows,
        env: this.env,
        envOpts: this.envOpts,
        mstate: this.mstate,
        cardRows: this.cardRows,
        subjectName: this.subjectName,
        subjectPlace: this.subjectPlace,
        assignTeacher: this.assignTeacher,
      };
    },
    // استعادة الحالة المحفوظة من المتصفح ودمجها مع الافتراضي
    loadState() {
      try {
        var raw = localStorage.getItem(this.storageKey);
        if (!raw) return;
        var s = JSON.parse(raw);
        if (!s || typeof s !== "object") return;
        if (Array.isArray(s.members)) this.members = s.members;
        if (Array.isArray(s.subjects)) this.subjects = s.subjects;
        if (Array.isArray(s.trackRows)) this.trackRows = s.trackRows;
        if (s.env && typeof s.env === "object")
          this.env = Object.assign({}, this.env, s.env);
        if (s.envOpts && typeof s.envOpts === "object")
          this.envOpts = Object.assign({}, this.envOpts, s.envOpts);
        if (s.mstate && typeof s.mstate === "object")
          this.mstate = Object.assign({}, this.mstate, s.mstate);
        if (Array.isArray(s.cardRows) && s.cardRows.length === this.cardRows.length)
          this.cardRows = s.cardRows;
        if (typeof s.subjectName === "string") this.subjectName = s.subjectName;
        if (typeof s.subjectPlace === "string") this.subjectPlace = s.subjectPlace;
        if (typeof s.assignTeacher === "string") this.assignTeacher = s.assignTeacher;
      } catch (e) {}
    },
    // نقل عنصر الكشف ليصبح ابناً مباشراً للـ body قبل الطباعة (يتجاوز كل حاويات القالب)
    // مع فرض العرض عبر أنماط inline (تتغلّب على أي قاعدة CSS من القالب في الـ build)
    relocateForPrint() {
      var el = this.$el;
      if (!el || this._printPlaceholder) return;
      this._printParent = el.parentNode;
      this._printPlaceholder = document.createComment("sk-print-anchor");
      if (this._printParent) this._printParent.insertBefore(this._printPlaceholder, el);
      document.body.appendChild(el);
      document.body.classList.add("sk-printing");
      // حفظ الأنماط الأصلية ثم فرض عرض كامل للورقة (inline !important يتغلّب على كل CSS)
      var force =
        "width:100%!important;min-width:0!important;max-width:none!important;margin:0!important;padding:0!important;";
      this._savedHtmlStyle = document.documentElement.getAttribute("style") || "";
      this._savedBodyStyle = document.body.getAttribute("style") || "";
      document.documentElement.style.cssText = this._savedHtmlStyle + ";" + force;
      document.body.style.cssText = this._savedBodyStyle + ";" + force;
      el.style.cssText =
        "width:100%!important;max-width:100%!important;margin:0!important;padding:0!important;";
      var page = el.querySelector(".sk-page");
      if (page) page.style.cssText = "width:100%!important;max-width:100%!important;margin:0!important;";
    },
    // إعادة العنصر إلى مكانه الأصلي بعد الطباعة
    restoreAfterPrint() {
      var el = this.$el;
      document.body.classList.remove("sk-printing");
      if (this._savedHtmlStyle != null) document.documentElement.setAttribute("style", this._savedHtmlStyle);
      if (this._savedBodyStyle != null) document.body.setAttribute("style", this._savedBodyStyle);
      if (el) {
        var page = el.querySelector(".sk-page");
        if (page) page.removeAttribute("style");
        el.removeAttribute("style");
      }
      if (this._printPlaceholder && this._printParent) {
        this._printParent.insertBefore(el, this._printPlaceholder);
        this._printParent.removeChild(this._printPlaceholder);
      }
      this._printPlaceholder = null;
      this._printParent = null;
      this._savedHtmlStyle = null;
      this._savedBodyStyle = null;
    },
    // تفريغ الحقول ومسح المحفوظ لهذا النموذج
    resetForm() {
      if (!confirm("سيتم مسح كل ما كتبته في هذا النموذج. هل أنت متأكد؟")) return;
      try {
        localStorage.removeItem(this.storageKey);
      } catch (e) {}
      window.location.reload();
    },
    // اختيار قائمة الاقتراحات لعمود جدول المتابعة (معلمون/طلاب/لا شيء)
    listFor(ci) {
      var src =
        (this.form.colSrc && this.form.colSrc[ci]) ||
        (ci === 0 && this.form.fromTeachers ? "teacher" : null);
      return this.srcList(src);
    },
    srcList(src) {
      return src === "teacher" ? "dl-teachers" : src === "student" ? "dl-students" : null;
    },
    addTrackRow() {
      this.trackRows.push(this.form.columns.map(() => ""));
    },
    addMemberRow(bi, mode) {
      this.mstate["m" + bi].push(makeMemberRow(mode));
    },
    print() {
      window.print();
    },
  },
};
</script>

<style>
body {
  background: #fff !important;
}
.sk {
  font-family: "Tahoma", "Arial", sans-serif;
  color: #000;
  padding: 10px;
}
.sk-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.sk-hint {
  color: #6e6b7b;
  font-size: 13px;
}
.sk-page {
  width: 185mm; /* عرض A4 عمودي بعد الهوامش */
  max-width: 100%;
  margin: 0 auto;
  background: #fff;
}
.sk.land .sk-page {
  width: 270mm; /* عرض A4 أفقي بعد الهوامش */
}
/* منع تمدّد الجداول خارج عرض الصفحة */
.sk-grid {
  table-layout: fixed;
}
.sk-grid td .cell,
.sk-grid .rightcell {
  overflow-wrap: anywhere;
  word-break: break-word;
}

/* الترويسة */
.sk-head {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 6px;
}
.sk-head td {
  vertical-align: middle;
  font-size: 13px;
}
.sk-head .r {
  text-align: right;
  width: 35%;
  line-height: 1.8;
}
.sk-head .c {
  text-align: center;
  width: 30%;
}
.sk-head .l {
  text-align: left;
  width: 35%;
}
.sk-head .bold {
  font-weight: bold;
}
.sk-head .logo {
  height: 64px;
  object-fit: contain;
}
.sk-head .box {
  display: inline-block;
  border: 1px solid #000;
  padding: 6px 10px;
  text-align: right;
  line-height: 1.9;
  font-size: 12px;
}

/* شريط العنوان */
.sk-title {
  width: 100%;
  border-collapse: collapse;
  margin: 8px 0;
}
.sk-title td {
  border: 1px solid #000;
  padding: 5px 8px;
  font-weight: bold;
}
.sk-title .lbl {
  background: #2e9b9b;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  width: 1%;
}
.sk-title .val {
  text-align: center;
}
.sk-title .num {
  background: #2e9b9b;
  color: #fff;
  text-align: center;
  width: 70px;
}

.intro {
  font-size: 14px;
  line-height: 1.9;
  margin: 8px 2px;
  text-align: right;
}
.intro .inline {
  border: none;
  border-bottom: 1px dotted #555;
  min-width: 120px;
  text-align: center;
}
.intro .w-50 {
  min-width: 45%;
}

/* الجداول */
.sk-grid {
  width: 100%;
  border-collapse: collapse;
  margin-top: 6px;
}
.sk-grid th,
.sk-grid td {
  border: 1px solid #000;
  padding: 0;
  font-size: 13px;
  text-align: center;
  vertical-align: middle;
}
.sk-grid thead th {
  background: #cfe8e8;
  font-weight: bold;
  padding: 5px 4px;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.sk-grid td .cell {
  width: 100%;
  border: none;
  background: transparent;
  padding: 7px 6px;
  font-size: 13px;
  text-align: center;
  font-family: inherit;
  color: #000;
}
.sk-grid td .cell:focus {
  outline: 2px solid #7367f0;
  background: #f5f4ff;
}
.sk-grid .center {
  position: relative;
}
.tracking th,
.tracking td {
  font-size: 11px;
}
.tracking td .cell {
  font-size: 11px;
  padding: 6px 2px;
}

/* جدول الظرف (مفتاح/قيمة) */
.sk-env {
  width: 70%;
  margin: 10px auto;
  border-collapse: collapse;
}
.sk-env td {
  border: 1px solid #000;
  padding: 0;
  font-size: 14px;
}
.sk-env .k {
  background: #cfe8e8;
  font-weight: bold;
  width: 38%;
  padding: 8px 10px;
  text-align: right;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
.sk-env .v .cell {
  width: 100%;
  border: none;
  background: transparent;
  padding: 8px 10px;
  font-size: 14px;
  font-family: inherit;
  color: #000;
}
.sk-env .v .opt {
  margin: 0 10px;
  font-size: 13px;
  cursor: pointer;
}

/* بطاقة المتابعة (قائمة تحقق) */
.sk-card.sk-grid .rightcell {
  text-align: right;
  padding: 5px 8px;
  font-size: 12.5px;
}
.sk-card.sk-grid td input[type="checkbox"] {
  width: 16px;
  height: 16px;
}
.sk-card.sk-grid thead th {
  font-size: 12.5px;
}
/* بطاقة الأيام: أعمدة الأيام مدمجة بعرض ثابت متساوٍ لتحاذي الرؤوس */
.sk-card.days .dcol {
  width: 11.4%;
  font-size: 9.5px;
  padding: 5px 1px;
}
.sk-card.days .rightcell {
  font-size: 11px;
}
.sk-card.days td input[type="checkbox"] {
  width: 15px;
  height: 15px;
}

/* عناصر المحضر */
.checks {
  margin: 8px 2px;
  font-size: 14px;
}
.checks-lbl {
  font-weight: bold;
  margin-left: 12px;
}
.opt {
  margin: 0 10px;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}
.lines {
  margin: 8px 2px;
}
.lines-lbl {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 3px;
}
.lines-area {
  width: 100%;
  border: none;
  border-bottom: 1px dotted #555;
  font-family: inherit;
  font-size: 13px;
  resize: vertical;
  background: repeating-linear-gradient(
    transparent,
    transparent 25px,
    #ccc 25px,
    #ccc 26px
  );
  line-height: 26px;
  padding: 0 4px;
  color: #000;
}
.signs {
  margin: 12px 2px;
}
.signs-lbl {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 4px;
}
.sign-line {
  display: flex;
  gap: 30px;
  font-size: 13px;
  padding: 6px 0;
  flex-wrap: wrap;
}
.sign-line .dots {
  display: inline-block;
  width: 130px;
  border-bottom: 1px dotted #555;
}

/* أزرار التحرير (لا تُطبع) */
.add-row {
  margin: 8px 0;
  border: 1px dashed #7367f0;
  background: #f5f4ff;
  color: #7367f0;
  border-radius: 6px;
  padding: 5px 14px;
  cursor: pointer;
  font-family: inherit;
}
.row-del {
  position: absolute;
  left: 2px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: #ea5455;
  color: #fff;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  line-height: 1;
  cursor: pointer;
  font-size: 12px;
}

.tasks-title {
  font-weight: bold;
  margin: 12px 2px 4px;
  font-size: 14px;
}
.tasks {
  font-size: 13px;
  line-height: 1.7;
  padding-right: 22px;
  text-align: left;
}
.tasks li {
  margin-bottom: 3px;
}

.sign-row {
  display: flex;
  justify-content: space-between;
  margin: 18px 6px 6px;
  font-size: 14px;
  font-weight: bold;
}
.note {
  margin-top: 8px;
  font-size: 13px;
  font-weight: bold;
}

@media print {
  /* عند الطباعة يُنقل الكشف (.sk) ليصبح ابناً مباشراً للـ body عبر JS،
     فيتجاوز كل حاويات القالب — بلا حيل position (متوافق مع كروم وسفاري). */
  html,
  body {
    width: 100% !important;
    min-width: 0 !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
  }
  /* أثناء الطباعة: أخفِ كل أبناء body عدا الكشف */
  body.sk-printing > *:not(.sk) {
    display: none !important;
  }
  .sk-toolbar,
  .add-row,
  .row-del {
    display: none !important;
  }
  .sk {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  /* عرض الصفحة = كامل عرض الورقة (يتكيّف مع أي هوامش/اتجاه فلا يتجاوز) */
  .sk-page {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
  }
  .sk-grid td .cell {
    outline: none !important;
    background: transparent !important;
  }
  .sk-title .lbl,
  .sk-title .num,
  .sk-grid thead th {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>
